import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Intent } from "@blueprintjs/core";
import SendEmailPanel from "components/Common/SendEmailPanel";
import Toast from 'helpers/toaster';

// Email a payment receipt to the client, in a side panel (components/Common/SendEmailPanel).
@inject("quoteStore", "paymentStore", "invoiceStore", "userStore")
@observer
class SendReceiptDialog extends Component {

  componentDidMount() {
    let { object } = this.props.invoiceStore.sendTransactionReceipt;
    object.emailSubject = "Receipt for Invoice #" +this.props.invoiceStore.invoice.object.attributes.number+ " from " +this.props.invoiceStore.invoice.object.attributes.tenant.name
  }

  handleSendReceiptDialog() {
    this.props.onClose();
  }

  SendReceiptToEmail() {
    this.props.invoiceStore.SendReceiptToEmail()
      .then(() => {
        this.props.onClose();
        Toast.show({ message: "Receipt sent.", intent: Intent.SUCCESS });
      })
      .catch((error) => {
        const errors = error.response && error.response.data && error.response.data.errors;
        Toast.show({
          message: errors ? [].concat(errors).join(' ') : "Couldn’t send the receipt. Try again.",
          intent: Intent.DANGER,
        });
      });
  }

  onEmailChange = (emails) => {
    this.props.invoiceStore.sendTransactionReceipt.object.emailTo = emails.map((contact) => contact.email);
  }

  render() {
    const { sendTransactionReceipt, invoice } = this.props.invoiceStore;
    const client = invoice.object.attributes && invoice.object.attributes.client;
    return (
      <SendEmailPanel
        isOpen={this.props.isOpen}
        onClose={this.handleSendReceiptDialog.bind(this)}
        what="receipt"
        tone="billing"
        object={sendTransactionReceipt.object}
        contacts={client ? [{ email: client.email, name: client.name }] : []}
        busy={Boolean(sendTransactionReceipt.isLoading)}
        onEmailChange={this.onEmailChange}
        onSend={this.SendReceiptToEmail.bind(this)}
      />
    )
  }

}

export default SendReceiptDialog;
